import { gql, useQuery } from "utils/urql";
import styles from "./Popular.module.scss";
import Image from "components/Image";
import SectionHeading from "./SectionHeading";
import { HomepageMostPopularQuery } from "types/api";
import HomepageMetadata from "./HomepageMetadata";

const query = gql`
  query HomepageMostPopular {
    mostPopular {
      river(first: 10) {
        edges {
          node {
            id
            url
            title
            authors {
              id
              displayName
              url
            }
            riverImage(width: 210, height: 130, sizes: ["1x", "2x"]) {
              url
              srcSet
              altText
              width
              height
            }
          }
        }
      }
    }
  }
`;

const Popular = () => {
  const [{ data }] = useQuery<HomepageMostPopularQuery>({ query });

  if (!data) return null;

  const articles = data.mostPopular.river.edges;

  return (
    <section className={styles.root} data-testid="homepage-popular">
      <SectionHeading
        title="Popular"
        secondaryLinkText="see all"
        url="https://www.theatlantic.com/most-popular/"
        analyticsSlug="popular"
      />
      <ol className={styles.ul}>
        {articles.map(({ node }, i) => (
          <li key={node.id} className={styles.listItem}>
            {node.riverImage && (
              <a
                href={node.url}
                data-action={`click link - popular - image ${i + 1}`}
              >
                <div className={styles.image}>
                  <Image
                    src={node.riverImage.url}
                    srcSet={node.riverImage.srcSet}
                    width={node.riverImage.width}
                    height={node.riverImage.height}
                    alt={node.riverImage.altText}
                    lazy={true}
                  />
                </div>
              </a>
            )}
            <div className={styles.textContainer}>
              <div>
                <a
                  href={node.url}
                  className={styles.title}
                  data-action={`click link - popular - title ${i + 1}`}
                  dangerouslySetInnerHTML={{ __html: node.title }}
                />
                <HomepageMetadata
                  authors={node.authors}
                  analyticsSection="popular"
                  riverIndex={i + 1}
                />
              </div>
            </div>
          </li>
        ))}
      </ol>
      <div className={styles.scroll}>Scroll →</div>
    </section>
  );
};

export default Popular;
